import { z } from "zod";

export const patchAssignmentSchema = z.object({
	crewId: z.uuid(),
	planId: z.uuid(),
	assignmentId: z.uuid(),
});
